export default __webpack_public_path__ + "static/media/10.fddb5dc8.svg";